import React from 'react';
import {Spacer} from 'components/spacer';

export const NullFieldPlaceholder = () => {
  return <Spacer size={4.5} />;
};
